<template>
  <div class="received-inve-details-page" style="height: 100%">
    <app-base-main parentTable>
      <template #filter-group >
        <app-filter-group
            @reset="$gjReset"
            @query="$gjNoticeQuery">

            <gj-warehouse-select
            v-model="filter.warehouseIds"
            multiple
            :self="false"
            placeholder="仓库"
            width="180px"
        ></gj-warehouse-select>

            <gj-select
              v-model="filter.inventoryActionTypes"
              type="multi-check"
              width="190px"
              :options="typeOption"
               placeholder="全部类型">
            </gj-select>

            <gj-select-input
              v-model="filter.keyword"
              :options="[
                  {id: 'msku', text: 'MSKU'},
                  {id: 'fnsku', text: 'FNSKU'},
                ]"
          ></gj-select-input>
          <gj-select-date-picker
                :width="['160px']"
                v-model="filter.date"
                :max-day-length="365"
                :options="[
                {id: 'zeroZoneDate', text: '日期（零时区）'},
                {id: 'marketDate', text: '日期（市场时区）'},
                ]"
                type="daterange"
            ></gj-select-date-picker>
            <template #right>
              <gj-tool-group
                :download="$permission('inventoryEventDetail:export')"
                download-url="/supply/inventoryEventDetail/export"
                :download-params="globalParams"
                setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
                help
              >
              </gj-tool-group>
            </template>
        </app-filter-group>
      </template>

      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            :data="tableData"
            :columns="columns"
            :pagination="pagination"
            :loading="loading"
            :size="'has-picture'"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
            :default-sort="{prop: 'warehouseName', order: 'descending'}">
            <template #skus="{ row }">
              <div><gj-tooltip :content="row.productName" :text-line="1">产品名称: {{row.productName || '-'}}</gj-tooltip></div>
              <div><gj-tooltip :content="row.sku" :text-line="1">sku: {{row.sku || '-'}}</gj-tooltip></div>
            </template>
            <template #MSKUs="{ row }">
              <div><gj-tooltip :content="row.fnsku" :text-line="1">fnsku: {{row.fnsku || '-'}}</gj-tooltip></div>
              <div><gj-tooltip :content="row.msku" :text-line="1">msku: {{row.msku || '-'}}</gj-tooltip></div>
            </template>
          </gj-table>
      </template>
    </app-base-main>
  </div>
</template>

<script>
import {queryMixin, } from "@/minxins";
import { receiptsInventoryExport } from '@/api/statistics'
import { convertToDate } from "@/utils/date.util.js"
import { subDays } from "date-fns";
export default {
  name: 'inve-action-details',
  mixins: [queryMixin],
  data() {
    return {
      tableData: [],
      columns: [
        { id: 'warehouseName', header: '仓库', field: 'warehouseName', minWidth: '120px', default: true, disabled: true, sortable: true },
        { id: 'sku', header: '产品名称/SKU', field: 'slot:skus', minWidth: '140px', default: true },
        { id: 'msku', header: 'FNSKU/MSKU', field: 'slot:MSKUs', minWidth: '120px', default: true },
        { id: 'quantity', header: '数量', field: 'quantity', minWidth: '120px', default: true, sortable: true },
        { id: 'transactionType', header: '类型', field: 'transactionType', minWidth: '120px', default: true, sortable: true },
        { id: 'fulfillmentCenterId', header: '亚马逊仓代码', field: 'fulfillmentCenterId', minWidth: '120px', default: true },
        { id: 'countryCode', header: '国家', field: 'countryCode', minWidth: '120px', default: true },
        { id: 'disposition', header: '描述', field: 'disposition', minWidth: '120px', default: true },
        { id: 'zeroTimeZoneDate', header: '日期（零时区）', field: 'zeroTimeZoneDate', minWidth: '120px', default: true, sortable: true },
        { id: 'marketDate', header: '日期（市场时区）', field: 'marketDate', minWidth: '120px', default: true, sortable: true }
      ],
      loading: false,
      typeOption: [
        { id: "Shipments", text: "Shipments"},
        { id: "Receipt", text: "Receipt" },
        { id: "VendorReturns", text: "VendorReturns" },
        { id: "WhseTransfers", text: "WhseTransfers" },
        { id: "Adjustments", text: "Adjustments" },
        { id: "CustomerReturns", text: "CustomerReturns" },
      ],
      filter: {
        inventoryActionTypes: [],
        keyword: {
          key: 'msku',
          value: ''
        },
        date: {
            key: 'zeroZoneDate',
            value: [subDays(new Date(), 30), new Date()],
        },
        warehouseIds: []
      },
      globalParams: {},
      tableName: "inve-action-details-table",
    }
  },
  created() {
    this.sort.prop = 'marketDate';
  },
  methods: {
    $gjQueryInitParams() {
      this.sort.prop = 'marketDate';
      return {
        filter: {
          inventoryActionTypes: [],
          keyword: {
            key: 'msku',
            value: ''
          },
          date: {
            key: 'zeroZoneDate',
            value: [subDays(new Date(), 30), new Date()],
          },
          warehouseIds: []
        }
      }
    },
    $gjQuery() {
      const params = {
        model: {
          warehouseIds: this.filter.warehouseIds,
          inventoryActionTypes: this.filter.inventoryActionTypes
        },
        ...this.queryPagination,
        ...this.querySort,
      }
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      if (this.filter.date.value && this.filter.date.key == 'zeroZoneDate') {
          params.model.startZeroZoneDate = convertToDate(this.filter.date.value[0])
          params.model.endZeroZoneDate = convertToDate(this.filter.date.value[1])
        }
      if (this.filter.date.value && this.filter.date.key == 'marketDate') {
          params.model.startMarketDate = convertToDate(this.filter.date.value[0])
          params.model.endMarketDate = convertToDate(this.filter.date.value[1])
      }
      this.globalParams = params
      this.loading = true
      receiptsInventoryExport(params).then(res => {
        // console.log(res)
        this.tableData = res.records
        this.pagination = this.getPagination(res);
      }).complete(_ => {
        this.loading = false
      })
    }
  }
}
</script>